(() => {
  let cleanup = () => {};
  function init() {
    cleanup();
    const abort = new AbortController();
    const signal = abort.signal;
    const root = document.documentElement;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    let paused = reduced.matches;
    try { paused = paused || sessionStorage.getItem('cocora-motion') === 'off'; } catch (_) {}
    root.classList.add('cc-js');
    const toggle = document.querySelector('[data-cc-menu-toggle]');
    const menu = document.getElementById('cc-mobile-menu');
    const closeMenu = () => { if (menu) menu.hidden = true; toggle?.setAttribute('aria-expanded', 'false'); };
    toggle?.addEventListener('click', () => { const open = toggle.getAttribute('aria-expanded') !== 'true'; toggle.setAttribute('aria-expanded', String(open)); menu.hidden = !open; }, { signal });
    menu?.querySelectorAll('a').forEach(a => a.addEventListener('click', closeMenu, { signal }));
    document.addEventListener('keydown', event => { if (event.key === 'Escape' && menu && !menu.hidden) { closeMenu(); toggle?.focus(); } }, { signal });
    window.matchMedia('(min-width: 701px)').addEventListener('change', closeMenu, { signal });
    let reveal;
    if ('IntersectionObserver' in window) {
      reveal = new IntersectionObserver(entries => entries.forEach(entry => { if (entry.isIntersecting) { entry.target.classList.add('cc-visible'); reveal.unobserve(entry.target); } }), { threshold: 0.08 });
      document.querySelectorAll('[data-cc-reveal]').forEach(el => reveal.observe(el));
    } else document.querySelectorAll('[data-cc-reveal]').forEach(el => el.classList.add('cc-visible'));
    const layers = [...document.querySelectorAll('[data-cc-parallax]')];
    const motion = document.querySelector('[data-cc-motion]');
    let frame = 0;
    function paint() {
      frame = 0;
      if (paused) return;
      const height = window.innerHeight;
      const scale = window.innerWidth < 701 ? 0.42 : 1;
      layers.forEach(layer => {
        const rect = layer.parentElement.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > height) return;
        const offset = (height / 2 - (rect.top + rect.height / 2)) * Number(layer.dataset.ccParallax) * scale;
        const limit = rect.height * .09;
        layer.style.transform = `translate3d(0,${Math.max(-limit, Math.min(limit, offset))}px,0)`;
      });
    }
    const queue = () => { if (!frame && !paused) frame = requestAnimationFrame(paint); };
    function updateMotion() {
      root.classList.toggle('cc-motion-off', paused);
      if (motion) { motion.textContent = paused ? 'Enable motion' : 'Pause motion'; motion.setAttribute('aria-pressed', String(paused)); }
      if (paused) layers.forEach(layer => layer.style.transform = ''); else queue();
    }
    motion?.addEventListener('click', () => { paused = !paused; try { sessionStorage.setItem('cocora-motion', paused ? 'off' : 'on'); } catch (_) {} updateMotion(); }, { signal });
    reduced.addEventListener('change', event => { paused = event.matches; updateMotion(); }, { signal });
    window.addEventListener('scroll', queue, { passive: true, signal });
    window.addEventListener('resize', queue, { passive: true, signal });
    updateMotion();
    cleanup = () => { abort.abort(); reveal?.disconnect(); if (frame) cancelAnimationFrame(frame); };
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
  document.addEventListener('shopify:section:load', init);
})();
